
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"44","height":"28","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"44","height":"28","rx":"3","fill":"#fff"}}),_c('path',{attrs:{"d":"M26.794 6.145h-8.682v15.768h8.682V6.145z","fill":"#FF5F00"}}),_c('path',{attrs:{"d":"M18.664 14.029c0-3.204 1.488-6.045 3.776-7.884A9.795 9.795 0 0016.32 4c-5.485 0-9.922 4.485-9.922 10.029s4.437 10.029 9.922 10.029a9.795 9.795 0 006.119-2.145c-2.288-1.811-3.776-4.68-3.776-7.884z","fill":"#EB001B"}}),_c('path',{attrs:{"d":"M38.508 14.029c0 5.544-4.437 10.029-9.922 10.029a9.795 9.795 0 01-6.118-2.145c2.315-1.839 3.776-4.68 3.776-7.884 0-3.204-1.489-6.045-3.776-7.884A9.795 9.795 0 0128.586 4c5.485 0 9.922 4.513 9.922 10.029z","fill":"#F79E1B"}})])
          )
        }
      }
    